import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Search, Lock, User, Phone, CreditCard, Download, Check, Loader2, AlertCircle, ArrowLeft } from 'lucide-react';
import config from '../config/config';
const ParentFeePayment = () => {
  const [currentStep, setCurrentStep] = useState('login');
  const [isLoading, setIsLoading] = useState(false);
  const [admissionNumber, setAdmissionNumber]=useState();
  const [formData, setFormData] = useState({
    parentPhone: '',
    parentName: '',
    admissionNumber: '',
    phoneNumber: '',
    amount: '',
    studentName: '',
    studentClass: '',
    feeBalance: 0,
    term:'',
    invoiceDetails: null,
    transactionId: ''
  });
  const [errors, setErrors] = useState({});
  const [stkPushSent, setStkPushSent] = useState(false);
  const [paymentComplete, setPaymentComplete] = useState(false);
  const [token, setToken] = useState('');

  // Axios instance for API calls
  const api = axios.create({
    baseURL: 'http://your-laravel-api-url/api', // Replace with your Laravel API URL
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });

  // Phone number validation and formatting
  const validatePhone = (phone) => {
    const phoneRegex = /^254[0-9]{9}$/;
    return phoneRegex.test(phone.replace(/\s/g, ''));
  };

  const formatPhone = (phone) => {
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.startsWith('0')) {
      return '' + cleaned.substring(1);
    }
    if (cleaned.startsWith('254')) {
      return '' + cleaned.substring(3);
    }
    if (cleaned.length === 9) {
      return '' + cleaned;
    }
    return cleaned;
  };

  // Handle login
  const handleLogin = async () => {
    setErrors({});
    
    if (!formData.parentPhone || !formData.parentName) {
      setErrors({ login: 'Please fill in all fields' });
      return;
    }

    const formattedPhone = formatPhone(formData.parentPhone);
    /**if (!validatePhone(formattedPhone)) {
      setErrors({ login: 'Please enter a valid phone number (254XXXXXXXXX)' });
      return;
    }**/

    setIsLoading(true);
    try {

    // 1. Fetch CSRF cookie
      await axios.get(config.API_URL + "/sanctum/csrf-cookie", {
        withCredentials: true,
      });

      // 2. Get CSRF token
      const getCookie = (name) => {
        const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
        if (match) return decodeURIComponent(match[2]);
        return null;
      };
      const xsrfToken = getCookie("XSRF-TOKEN");

    const response = await axios.post(
      `${config.API_URL}/api/parent_login`,
      {
        phone: formattedPhone,
        password: formData.parentName
      },
      {
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-XSRF-TOKEN": xsrfToken,
          },
          withCredentials: true,
      }
    );


      setToken(response.data.token);
      setFormData(prev => ({ ...prev, parentPhone: formattedPhone, parentName: response.data.student?.parent_firstname+" "+response.data.student?.parent_lastname }));
      setCurrentStep('search');
    } catch (error) {
      setErrors({ login: error.response?.data?.error || 'Login failed' });
    } finally {
      setIsLoading(false);
    }
  };

  // Handle student search
  const handleStudentSearch = async () => {
    setErrors({});
    
    if (!formData.admissionNumber) {
      setErrors({ search: 'Please enter admission number' });
      return;
    }

    setIsLoading(true);
    try {
      const token = localStorage.getItem('token');
       
       // 1. Fetch CSRF cookie
      await axios.get(config.API_URL + "/sanctum/csrf-cookie", {
        withCredentials: true,
      });

      // 2. Get CSRF token
      const getCookie = (name) => {
        const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
        if (match) return decodeURIComponent(match[2]);
        return null;
      };
      const xsrfToken = getCookie("XSRF-TOKEN");

    const response = await axios.post(
      `${config.API_URL}/api/student_search`,
      {
       admission_number: formData.admissionNumber.toUpperCase()
      },
      {
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-XSRF-TOKEN": xsrfToken,
          },
          withCredentials: true,
      }
    );

      const { student } = response.data.student;
      //alert(response.data.admission_number);
      setAdmissionNumber(response.data.admission_number);
      setFormData(prev => ({
        ...prev,
        studentName: student?.name,
        studentClass: student?.class,
        feeBalance: student?.fee_balance,
        admissionNumber: student?.admission_number
      }));
      setCurrentStep('invoice');
    } catch (error) {
      setErrors({ search: error.response?.data?.error || 'Student not found' });
    } finally {
      setIsLoading(false);
    }
  };

  // Handle payment
  const handlePayment = async () => {
    setErrors({});
    
    const formattedPhone = formatPhone(formData.phoneNumber);
    /**if (!validatePhone(formattedPhone)) {
      setErrors({ payment: 'Please enter a valid M-Pesa phone number i.e 254704xxxxxx' });
      return;
    }**/

    const amount = parseFloat(formData.amount);
    /** if (!amount || amount <= 0 || amount > formData.feeBalance) {
      setErrors({ payment: `Amount must be between 1 and ${formData.feeBalance}` });
      return;
    }**/

    setIsLoading(true);
     setStkPushSent(true);
      setCurrentStep('stk-push');
      alert('Payment stk push will be sent to your phone');
       setPaymentComplete(true);
      setCurrentStep('receipt');
    try {
      const response = await api.post('/payment', {
        admission_number: formData.admissionNumber,
        phone_number: formattedPhone,
        amount
      });

      setFormData(prev => ({ 
        ...prev, 
        phoneNumber: formattedPhone,
        transactionId: response.data.transaction_id
      }));
      setStkPushSent(true);
      setCurrentStep('stk-push');

      // Poll for payment status
      setTimeout(async () => {
        try {
          const receiptResponse = await api.get(`/payment/${response.data.transaction_id}/receipt`);
          setPaymentComplete(true);
          setCurrentStep('receipt');
        } catch (error) {
          setErrors({ payment: error.response?.data?.error || 'Payment verification failed' });
        }
      }, 8000);
    } catch (error) {
      setErrors({ payment: error.response?.data?.error || 'Payment processing failed' });
    } finally {
      setIsLoading(false);
    }
  };

  // Download receipt
  const downloadReceipt = async () => {
    try {
      const response = await api.get(`/payment/${formData.transactionId}/receipt`);
      const { receipt } = response.data;

      const receiptContent = `
SCHOOL FEE PAYMENT RECEIPT
========================
Transaction ID: ${receipt.transaction_id}
Date: ${new Date(receipt.payment_date).toLocaleDateString()}
Time: ${new Date(receipt.payment_date).toLocaleTimeString()}

Student Details:
Name: ${receipt.student_name}
Class: ${receipt.student_class}
Admission No: ${receipt.admission_number}

Payment Details:
Amount Paid: KSh ${parseFloat(receipt.amount).toLocaleString()}
Payment Method: M-Pesa
Phone Number: ${receipt.phone_number}

Thank you for your payment!
`;

      const blob = new Blob([receiptContent], { type: 'text/plain' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `receipt-${receipt.transaction_id}.txt`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      setErrors({ receipt: error.response?.data?.error || 'Failed to download receipt' });
    }
  };

  // Reset form
  const resetForm = () => {
    setCurrentStep('login');
    setFormData({
      parentPhone: '',
      parentName: '',
      admissionNumber: '',
      phoneNumber: '',
      amount: '',
      studentName: '',
      studentClass: '',
      term:'',
      feeBalance: 0,
      invoiceDetails: null,
      transactionId: ''
    });
    setErrors({});
    setStkPushSent(false);
    setPaymentComplete(false);
    setToken('');
  };

  // Fetch invoice details when entering invoice step
  useEffect(() => {
    if (currentStep === 'invoice') {
      const fetchInvoice = async () => {
        setIsLoading(true);
        try {
           // 1. Fetch CSRF cookie
      await axios.get(config.API_URL + "/sanctum/csrf-cookie", {
        withCredentials: true,
      });

      // 2. Get CSRF token
      const getCookie = (name) => {
        const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
        if (match) return decodeURIComponent(match[2]);
        return null;
      };
      const xsrfToken = getCookie("XSRF-TOKEN");

    const response = await axios.get(
      `${config.API_URL}/api/student_invoice/${admissionNumber}`,
      {
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-XSRF-TOKEN": xsrfToken,
          },
          withCredentials: true,
      }
    );
          const { student, invoice } = response.data;
          setFormData(prev => ({
            ...prev,
            studentName: student.studentName,
            studentClass: student.studentClass,
            feeBalance: student.feeBalance,
            admissionNumber: student.admissionNumber,
            invoiceDetails: response.data.invoice
          }));
           
        } catch (error) {
          setErrors({ invoice: error.response?.data?.error || 'Failed to fetch invoice' });
          setCurrentStep('search');
        } finally {
          setIsLoading(false);
        }
      };
      fetchInvoice();
    }
  }, [currentStep, formData.admissionNumber]);

  // Login Step
  if (currentStep === 'login') {
    return (
      <div className="w-full sm:max-w-md sm:mx-auto bg-white min-h-screen">
        <div className="px-5 py-8 mt-8">
          {/* Header */}
          <div className="text-center mb-8">
            <a href="https://joharischool.co.ke">
              <center>
                <img
                  src="https://joharischool.co.ke/wp-content/uploads/2022/01/download.png"
                  className="rounded"
                  style={{ width: '120px', height: '100px' }}
                  alt="Johari School Logo"
                />
              </center>
              <h1 className="text-xl mt-3 sm:text-3xl font-bold bg-gradient-to-r from-gray-900 to-gray-600 bg-clip-text text-transparent mb-2">
                Parent Portal
              </h1>
              <div className="w-16 h-1 bg-[#ff7713] rounded-full mx-auto mt-2 sm:mt-3"></div>
              <p className="text-gray-600">Login to pay school fees</p>
            </a>
          </div>

          {/* Login Form */}
          <div className="space-y-6">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Parent Phone
              </label>
              <input
                type="tel"
                value={formData.parentPhone}
                onChange={(e) => setFormData({ ...formData, parentPhone: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                placeholder="0712345678"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Password
              </label>
              <input
                type="password"
                value={formData.parentName}
                onChange={(e) => setFormData({ ...formData, parentName: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                placeholder="Enter your password"
              />
            </div>

            {errors.login && (
              <div className="flex items-center space-x-2 text-red-600 bg-red-50 p-3 rounded-lg">
                <AlertCircle className="w-4 h-4" />
                <span className="text-sm">{errors.login}</span>
              </div>
            )}

            <button
              onClick={handleLogin}
              disabled={isLoading}
              style={{ backgroundColor: 'rgb(2, 3, 129)' }}
              className="w-full text-white font-semibold py-3 sm:py-4 px-6 rounded-xl shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center space-x-2 text-sm sm:text-base"
            >
              {isLoading ? (
                <>
                  <Loader2 className="w-5 h-5 animate-spin" />
                  <span>Please wait...</span>
                </>
              ) : (
                <>
                  <Lock className="w-5 h-5" />
                  <span>Sign In</span>
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Student Search Step
  if (currentStep === 'search') {
    return (
      <div className="max-w-md mx-auto bg-white min-h-screen">
        <div className="px-6 py-8">
          {/* Header */}
          <div className="flex items-center mb-6">
            <button onClick={() => setCurrentStep('login')} className="mr-4">
              <ArrowLeft className="w-6 h-6 text-gray-600" />
            </button>
            <h1 className="text-xl font-bold text-gray-900">Find Student</h1>
          </div>

          {/* Welcome message */}
          <div className="bg-blue-50 p-4 rounded-xl mb-6">
            <p className="text-blue-800">Welcome, {formData.parentName}!</p>
          </div>

          {/* Search Form */}
          <div className="space-y-6">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Student Admission Number
              </label>
              <div className="relative">
                <Search className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2" />
                <input
                  type="text"
                  value={formData.admissionNumber}
                  onChange={(e) => setFormData({ ...formData, admissionNumber: e.target.value })}
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                  placeholder="e.g., 101"
                />
              </div>
            </div>

            {errors.search && (
              <div className="flex items-center space-x-2 text-red-600 bg-red-50 p-3 rounded-lg">
                <AlertCircle className="w-4 h-4" />
                <span className="text-sm">{errors.search}</span>
              </div>
            )}

            <button
              onClick={handleStudentSearch}
              disabled={isLoading}
              className="w-full bg-gradient-to-r from-green-500 to-green-600 text-white py-3 px-6 rounded-xl font-semibold hover:from-green-600 hover:to-green-700 transition-all duration-200 transform hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center space-x-2"
            >
              {isLoading ? (
                <>
                  <Loader2 className="w-5 h-5 animate-spin" />
                  <span>Searching...</span>
                </>
              ) : (
                <>
                  <Search className="w-5 h-5" />
                  <span>Search Student</span>
                </>
              )}
            </button>
          </div>

          
          
        </div>
      </div>
    );
  }

  // Invoice Step
  if (currentStep === 'invoice') {
    return (
      <div className="max-w-md mx-auto bg-white min-h-screen">
        <div className="px-6 py-8">
          {/* Header */}
          <div className="flex items-center mb-6">
            <button onClick={() => setCurrentStep('search')} className="mr-4">
              <ArrowLeft className="w-6 h-6 text-gray-600" />
            </button>
            <h1 className="text-xl font-bold text-gray-900">Fee Invoice</h1>
          </div>

          {/* Loading State */}
          {isLoading ? (
            <div className="text-center">
              <Loader2 className="w-8 h-8 animate-spin mx-auto text-blue-500" />
              <p className="text-gray-600 mt-2">Loading invoice...</p>
            </div>
          ) : (
            <>
              {/* Student Info Card */}
              <div className="bg-gradient-to-r from-purple-500 to-purple-600 text-white p-6 rounded-xl mb-6">
                <h2 className="text-xl font-bold mb-2">{formData.studentName}</h2>
                <p className="opacity-90">Class: {formData.studentClass}</p>
                <p className="opacity-90">Admission: {formData.admissionNumber}</p>
              </div>

              
              {/* Invoice Details */}
              {formData.invoiceDetails && (
                <div className="bg-gray-50 p-6 rounded-xl mb-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Invoice Details</h3>
                  
                  <div className="space-y-3">
                    {formData.invoiceDetails && Object.entries(formData.invoiceDetails).map(([key, value]) => (
                    
                    <div key={key} className="flex justify-between">
                      <span className="text-gray-600 text-sm">{key.replace(/([A-Z])/g, ' $1')}</span>
                      <span className="font-semibold text-sm">KSh {value}</span>
                    </div>
                  ))}
                    <hr className="my-3" />
                    <div className="flex justify-between text-md font-bold text-red-600">
                      <span>Total Outstanding</span>
                      <span>KSh {parseFloat(formData.feeBalance).toLocaleString()}</span>
                    </div>
                    
                  </div>
                </div>
              )}

              {errors.invoice && (
                <div className="flex items-center space-x-2 text-red-600 bg-red-50 p-3 rounded-lg">
                  <AlertCircle className="w-4 h-4" />
                  <span className="text-sm">{errors.invoice}</span>
                </div>
              )}

              {/* Payment Button */}
              <button
                onClick={() => setCurrentStep('payment')}
                className="w-full bg-gradient-to-r from-green-500 to-green-600 text-white py-4 px-6 rounded-xl font-semibold hover:from-green-600 hover:to-green-700 transition-all duration-200 transform hover:scale-[1.02] flex items-center justify-center space-x-2"
              >
                <CreditCard className="w-5 h-5" />
                <span>Pay with M-Pesa</span>
              </button>
            </>
          )}
        </div>
      </div>
    );
  }

  // Payment Step
  if (currentStep === 'payment') {
    return (
      <div className="max-w-md mx-auto bg-white min-h-screen">
        <div className="px-6 py-8">
          {/* Header */}
          <div className="flex items-center mb-6">
            <button onClick={() => setCurrentStep('invoice')} className="mr-4">
              <ArrowLeft className="w-6 h-6 text-gray-600" />
            </button>
            <h1 className="text-xl font-bold text-gray-900">M-Pesa Payment</h1>
          </div>

          {/* Student Summary */}
          <div className="bg-blue-50 p-4 rounded-xl mb-6">
            <p className="font-semibold text-blue-900">{formData.studentName}</p>
            <p className="text-blue-700 text-sm">Outstanding: KSh {parseFloat(formData.feeBalance).toLocaleString()}</p>
          </div>

          {/* Payment Form */}
          <div className="space-y-6">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                M-Pesa Phone Number
              </label>
              <div className="relative">
                <Phone className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2" />
                <input
                  type="tel"
                  value={formData.phoneNumber}
                  onChange={(e) => setFormData({ ...formData, phoneNumber: e.target.value })}
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200"
                  placeholder="0712345678"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Amount to Pay (KSh)
              </label>
              <input
                type="number"
                value={formData.amount}
                onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200"
                placeholder="Enter amount"
                max={formData.feeBalance}
                min="1"
              />
              <p className="text-xs text-gray-500 mt-1">
                Maximum: KSh {parseFloat(formData.feeBalance).toLocaleString()}
              </p>
            </div>

            {errors.payment && (
              <div className="flex items-center space-x-2 text-red-600 bg-red-50 p-3 rounded-lg">
                <AlertCircle className="w-4 h-4" />
                <span className="text-sm">{errors.payment}</span>
              </div>
            )}

            <button
              onClick={handlePayment}
              disabled={isLoading}
              className="w-full bg-gradient-to-r from-green-500 to-green-600 text-white py-4 px-6 rounded-xl font-semibold hover:from-green-600 hover:to-green-700 transition-all duration-200 transform hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center space-x-2"
            >
              {isLoading ? (
                <>
                  <Loader2 className="w-5 h-5 animate-spin" />
                  <span>Processing...</span>
                </>
              ) : (
                <>
                  <Phone className="w-5 h-5" />
                  <span>Send STK Push</span>
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    );
  }

  // STK Push Step
  if (currentStep === 'stk-push') {
    return (
      <div className="max-w-md mx-auto bg-white min-h-screen">
        <div className="px-6 py-8 text-center">
          {/* Animation */}
          <div className="w-24 h-24 mx-auto mb-6">
            {!paymentComplete ? (
              <div className="w-24 h-24 border-4 border-green-200 border-t-green-500 rounded-full animate-spin"></div>
            ) : (
              <div className="w-24 h-24 bg-green-500 rounded-full flex items-center justify-center">
                <Check className="w-12 h-12 text-white" />
              </div>
            )}
          </div>

          {!paymentComplete ? (
            <>
              <h2 className="text-xl font-bold text-gray-900 mb-4">STK Push Sent!</h2>
              <p className="text-gray-600 mb-6">
                Please check your phone and enter your M-Pesa PIN to complete the payment.
              </p>
              <div className="bg-green-50 p-4 rounded-xl">
                <p className="text-green-800 font-semibold">Amount: KSh {parseFloat(formData.amount).toLocaleString()}</p>
                <p className="text-green-700">Phone: {formData.phoneNumber}</p>
              </div>
            </>
          ) : (
            <>
              <h2 className="text-xl font-bold text-green-600 mb-4">Payment Successful!</h2>
              <p className="text-gray-600 mb-6">
                Your payment has been processed successfully.
              </p>
              <button
                onClick={() => setCurrentStep('receipt')}
                className="w-full bg-gradient-to-r from-blue-500 to-blue-600 text-white py-3 px-6 rounded-xl font-semibold hover:from-blue-600 hover:to-blue-700 transition-all duration-200 transform hover:scale-[1.02]"
              >
                View Receipt
              </button>
            </>
          )}
        </div>
      </div>
    );
  }

  // Receipt Step
  if (currentStep === 'receipt') {
    return (
      <div className="max-w-md mx-auto bg-white min-h-screen">
        <div className="px-6 py-8">
          {/* Success Header */}
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <Check className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-2xl font-bold text-green-600 mb-2">Payment Successful!</h1>
          </div>

          {/* Receipt */}
          <div className="bg-gray-50 p-6 rounded-xl mb-6">
            <h3 className="text-lg font-bold text-gray-900 mb-4 text-center">Payment Receipt</h3>
            
            <div className="space-y-3 text-sm">
              <div className="flex justify-between">
                <span className="text-gray-600">Transaction ID</span>
                <span className="font-mono font-semibold">{formData.transactionId}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Date</span>
                <span className="font-semibold">{new Date().toLocaleDateString()}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Time</span>
                <span className="font-semibold">{new Date().toLocaleTimeString()}</span>
              </div>
              <hr className="my-3" />
              <div className="flex justify-between">
                <span className="text-gray-600">Student Name</span>
                <span className="font-semibold">{formData.studentName}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Admission No.</span>
                <span className="font-semibold">{formData.admissionNumber}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Class</span>
                <span className="font-semibold">{formData.studentClass}</span>
              </div>
              <hr className="my-3" />
              <div className="flex justify-between">
                <span className="text-gray-600">Payment Method</span>
                <span className="font-semibold">M-Pesa</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Phone Number</span>
                <span className="font-semibold">{formData.phoneNumber}</span>
              </div>
              <div className="flex justify-between text-lg font-bold text-green-600">
                <span>Amount Paid</span>
                <span>KSh {parseFloat(formData.amount).toLocaleString()}</span>
              </div>
            </div>
          </div>

          {errors.receipt && (
            <div className="flex items-center space-x-2 text-red-600 bg-red-50 p-3 rounded-lg">
              <AlertCircle className="w-4 h-4" />
              <span className="text-sm">{errors.receipt}</span>
            </div>
          )}

          {/* Action Buttons */}
          <div className="space-y-4">
            <button
              onClick={downloadReceipt}
              className="w-full bg-gradient-to-r from-blue-500 to-blue-600 text-white py-3 px-6 rounded-xl font-semibold hover:from-blue-600 hover:to-blue-700 transition-all duration-200 transform hover:scale-[1.02] flex items-center justify-center space-x-2"
            >
              <Download className="w-5 h-5" />
              <span>Download Receipt</span>
            </button>

            <button
              onClick={resetForm}
              className="w-full bg-gray-100 text-gray-700 py-3 px-6 rounded-xl font-semibold hover:bg-gray-200 transition-all duration-200 transform hover:scale-[1.02]"
            >
              Make Another Payment
            </button>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default ParentFeePayment;